import { Bell } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';
import { useNavigate } from 'react-router-dom';

interface NotificationBellProps {
    className?: string;
}

export default function NotificationBell({ className = "" }: NotificationBellProps) {
    const { unreadCount } = useNotifications();
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate('/app/notifications')}
            className={`relative p-2 rounded-full hover:bg-slate-800 transition ${className}`}
        >
            <Bell size={24} className="text-white" />
            {unreadCount > 0 && (
                <span className="absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-slate-900 animate-pulse">
                    {unreadCount > 9 ? '9+' : unreadCount}
                </span>
            )}
        </button>
    );
}
